import React from "react";

interface ReviewContactCardProps {
  name: string;
  phone: string;
  email: string;
}

export const ReviewContactCard = ({
  name,
  phone,
  email,
}: ReviewContactCardProps) => (
  <div className="flex flex-col gap-2">
    <p className="font-semibold text-sm text-light-black leading-[14px]">
      {"Your Contact Information"}
    </p>
    <div className="bg-white border border-taupe-50 rounded-lg p-3
      flex flex-col gap-1"
    >
      <span className="font-semibold text-sm text-light-black leading-5">
        {name}
      </span>
      <span className="text-sm text-light-black leading-5">
        {phone}
      </span>
      <span className="text-sm text-light-black leading-5">
        {email}
      </span>
    </div>
  </div>
);
